/* eslint-disable prefer-arrow/prefer-arrow-functions */
function Pagination({ totalPages, page, setPage }) {
  return (
    <nav className="d-flex justify-content-center">
      <ul className="pagination">
        {[...Array(totalPages)].map((_, idx) => (
          <li
            key={idx}
            className={`page-item ${page === idx + 1 ? 'active' : ''}`}
          >
            <button
              className="page-link"
              onClick={() => setPage(idx + 1)}
            >
              {idx + 1}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Pagination;
